import { render, staticRenderFns } from "./OpenCartOrderDetails.vue?vue&type=template&id=9bea4400&"
import script from "./OpenCartOrderDetails.vue?vue&type=script&lang=js&"
export * from "./OpenCartOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartOrderDetails.vue"
export default component.exports